import { Logger } from '../../packages/logger/src/Logger';
import { AClientBuilder } from './ClientBuilder';
import config from '../../../src/config';

export default class RawClientBuilder extends AClientBuilder {
  constructor() {
    super(`${config.JABBER_INTEGRATION_URL}`);
  }

  addRetryConfiguration(): void {
    Logger.debug('No retry configuration on raw client');
  }

  addAuthorizationInterceptor(): void {
    Logger.debug('No authorization interceptor on raw client');
  }
}
